﻿(function() {
  const selectors = {
    section: ".js-retailer-locator",
    form: ".js-retailer-locator-search",
    input: ".js-retailer-locator-input",
    locationButton: ".js-retailer-locator-location",
    typeFilterButton: ".js-retailer-locator-type-filter",
    status: ".js-retailer-locator-status",
    results: ".js-retailer-locator-results",
    empty: ".js-retailer-locator-empty",
    moreButton: ".js-retailer-locator-more",
    map: ".js-retailer-locator-map",
    selected: ".js-retailer-locator-selected",
    mapFallback: ".js-retailer-locator-map-fallback",
    locationContext: ".js-retailer-locator-location-context"
  };
  const defaultCenter = [45.4642, 9.19];
  const defaultZoom = 11;

  function escapeHtml(value) {
    return String(value ?? "").replace(/[&<>"']/g, (char) => {
      const entities = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      return entities[char];
    });
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "it-IT", { style: "currency", currency: currency || "EUR" }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return `${((Number(cents) || 0) / 100).toFixed(2)} €`;
    }
  }

  async function populateCartSummary(modal) {
    const summary = modal.querySelector(".js-retailer-cart-summary");
    const itemsElement = modal.querySelector(".js-retailer-cart-items");
    const countElement = modal.querySelector(".js-retailer-cart-count");
    const emptyElement = modal.querySelector(".retailer-locator__cart-empty");
    const contentsInput = modal.querySelector(".js-retailer-cart-contents");
    const tokenInput = modal.querySelector(".js-retailer-cart-token");
    if (!summary || !itemsElement || !contentsInput || !tokenInput) return;
    summary.hidden = false;
    itemsElement.innerHTML = "";
    countElement.textContent = "Caricamento…";
    emptyElement.hidden = true;
    contentsInput.value = "";
    tokenInput.value = "";
    try {
      const response = await fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" });
      if (!response.ok) throw new Error("Unable to load cart");
      const cart = await response.json();
      const items = Array.isArray(cart.items) ? cart.items : [];
      tokenInput.value = cart.token || "";
      contentsInput.value = items.map((item) => `${item.title}${item.variant_title && item.variant_title !== "Default Title" ? ` — ${item.variant_title}` : ""} × ${item.quantity}`).join("; ");
      countElement.textContent = items.length ? `${cart.item_count} ${cart.item_count === 1 ? "articolo" : "articoli"}` : "Vuoto";
      emptyElement.hidden = items.length > 0;
      itemsElement.innerHTML = items.map((item) => `<div class="retailer-locator__cart-item"><span>${escapeHtml(item.title)}${item.variant_title && item.variant_title !== "Default Title" ? ` · ${escapeHtml(item.variant_title)}` : ""}</span><span>× ${escapeHtml(item.quantity)} · ${escapeHtml(formatMoney(item.final_line_price, cart.currency))}</span></div>`).join("");
    } catch (_) {
      countElement.textContent = "Non disponibile";
      emptyElement.hidden = false;
      emptyElement.textContent = "Non è stato possibile leggere il carrello. Puoi comunque inviare la richiesta.";
    }
  }

  function slugify(value) {
    return String(value ?? "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");
  }

  function normalizeStore(store, index) {
    const name = store.name || store.title || `Punto vendita ${index + 1}`;
    const lat = Number.parseFloat(store.lat);
    const lng = Number.parseFloat(store.lng);
    const address = store.address || "";
    const postalCode = store.postal_code || store.zip || "";
    const city = store.city || "";
    const province = store.province || "";
    const locality = [postalCode, city ? `${city}${province ? ` (${province})` : ""}` : province].filter(Boolean).join(" ");
    const phone = store.phone || "";
    const email = store.email || "";
    const hours = store.hours || "";
    const type = store.type || "";
    const typeKey = slugify(type) || "store";
    const mapsUrl = store.maps_url || "";

    return {
      id: store.id || `${slugify(name) || "store"}-${index + 1}`,
      name,
      type,
      typeKey,
      address,
      postalCode,
      city,
      province,
      locality,
      phone,
      email,
      hours,
      lat: Number.isFinite(lat) ? lat : null,
      lng: Number.isFinite(lng) ? lng : null,
      mapsUrl,
      searchText: [
        name,
        type,
        address,
        postalCode,
        city,
        province,
        phone,
        email
      ].join(" ").toLowerCase()
    };
  }

  function parseDataset(payload) {
    const items = Array.isArray(payload) ? payload : payload && Array.isArray(payload.stores) ? payload.stores : [];
    return items.map(normalizeStore);
  }

  function toMapsUrl(store) {
    if (store.mapsUrl) {
      return store.mapsUrl;
    }

    if (store.lat !== null && store.lng !== null) {
      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${store.lat},${store.lng}`)}`;
    }

    const query = [store.address, store.postalCode, store.city, store.province].filter(Boolean).join(", ");
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
  }

  function toDirectionsUrl(store) {
    const destination = store.lat !== null && store.lng !== null ? `${store.lat},${store.lng}` : [store.address, store.postalCode, store.city, store.province].filter(Boolean).join(", ");
    return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}`;
  }

  function trackStoreEvent(eventName, store) {
    const detail = { event: eventName, store_id: store.id, store_name: store.name, store_type: store.type, store_city: store.city, store_province: store.province };
    window.dataLayer = window.dataLayer || []; window.dataLayer.push(detail);
    document.dispatchEvent(new CustomEvent(`retailer:${eventName}`, { detail }));
  }

  function renderSelectedStore(sectionState) {
    const store = sectionState.filteredStores.find((item) => item.id === sectionState.activeStoreId); const panel = sectionState.elements.selected;
    if (!store) { panel.hidden = true; panel.innerHTML = ""; return; }
    sectionState.section.__retailerLocatorStoreState = sectionState.section.__retailerLocatorStoreState || {};
    sectionState.section.__retailerLocatorStoreState[store.id] = store;
    const telUrl = toTelUrl(store.phone);
    panel.innerHTML = `<p class="retailer-locator__selected-label">Punto vendita selezionato</p><div class="retailer-locator__selected-head"><div><h2 class="retailer-locator__selected-name">${escapeHtml(store.name)}</h2>${store.type ? `<p class="retailer-locator__selected-type">${escapeHtml(store.type)}</p>` : ""}</div>${formatDistance(store.distanceKm) ? `<strong class="retailer-locator__selected-distance">${escapeHtml(formatDistance(store.distanceKm))}</strong>` : ""}</div>${store.address ? `<p class="retailer-locator__selected-address">${escapeHtml(store.address)}</p>` : ""}${store.locality ? `<p class="retailer-locator__selected-address">${escapeHtml(store.locality)}</p>` : ""}${telUrl ? `<p class="retailer-locator__selected-phone">Telefono: <a class="js-retailer-call" href="${escapeHtml(telUrl)}" data-store-id="${escapeHtml(store.id)}">${escapeHtml(store.phone)}</a></p>` : ""}<div class="retailer-locator__selected-actions"><a class="retailer-locator__selected-primary js-retailer-directions" href="${escapeHtml(toDirectionsUrl(store))}" target="_blank" rel="noopener noreferrer" data-store-id="${escapeHtml(store.id)}">Ottieni indicazioni</a>${telUrl ? `<a class="retailer-locator__selected-secondary js-retailer-call" href="${escapeHtml(telUrl)}" data-store-id="${escapeHtml(store.id)}">Chiama</a>` : ""}<button type="button" class="retailer-locator__selected-secondary js-retailer-store-buy" data-store-id="${escapeHtml(store.id)}">Acquista in negozio</button></div>`;
    panel.hidden = false;
  }

  function toTelUrl(phone) {
    const normalized = String(phone ?? "").replace(/[^+\d]/g, "");
    return normalized ? `tel:${normalized}` : "";
  }

  function formatIndex(index) {
    return String(index + 1).padStart(2, "0");
  }

  function haversineDistance(coordsA, coordsB) {
    const toRadians = (value) => value * Math.PI / 180;
    const earthRadiusKm = 6371;
    const deltaLat = toRadians(coordsB.lat - coordsA.lat);
    const deltaLng = toRadians(coordsB.lng - coordsA.lng);
    const latA = toRadians(coordsA.lat);
    const latB = toRadians(coordsB.lat);
    const a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) + Math.cos(latA) * Math.cos(latB) * Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);
    return earthRadiusKm * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function formatDistance(distanceKm) {
    if (!Number.isFinite(distanceKm)) {
      return "";
    }

    if (distanceKm < 1) {
      return `${Math.round(distanceKm * 1000)} m`;
    }

    const formatter = new Intl.NumberFormat("it-IT", {
      minimumFractionDigits: distanceKm < 10 ? 1 : 0,
      maximumFractionDigits: distanceKm < 10 ? 1 : 0
    });
    return `${formatter.format(distanceKm)} km`;
  }

  async function geocodeQuery(query) {
    const params = new URLSearchParams({
      format: "jsonv2",
      limit: "1",
      countrycodes: "it",
      "accept-language": "it",
      q: query
    });
    const response = await fetch(`https://nominatim.openstreetmap.org/search?${params.toString()}`, {
      headers: {
        Accept: "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(`Geocoding failed: ${response.status}`);
    }

    const payload = await response.json();
    const match = Array.isArray(payload) ? payload[0] : null;
    const lat = Number.parseFloat(match && match.lat);
    const lng = Number.parseFloat(match && match.lon);

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return null;
    }

    return {
      lat,
      lng,
      label: query
    };
  }

  async function reverseGeocode(coords) {
    const params = new URLSearchParams({ format: "jsonv2", lat: String(coords.lat), lon: String(coords.lng), zoom: "18", "accept-language": "it" });
    const response = await fetch(`https://nominatim.openstreetmap.org/reverse?${params.toString()}`, { headers: { Accept: "application/json" } });
    if (!response.ok) throw new Error("Reverse geocoding failed");
    const result = await response.json();
    return result.display_name || "";
  }

  function setLocationContext(sectionState, label) {
    const context = sectionState.elements.locationContext;
    if (!context) return;
    context.hidden = !label;
    context.innerHTML = label ? `Distanze calcolate da: <strong>${escapeHtml(label)}</strong>` : "";
  }

  function waitForLeaflet() {
    return new Promise((resolve) => {
      if (window.L) {
        resolve(window.L);
        return;
      }

      let attempts = 0;
      const timer = window.setInterval(() => {
        attempts += 1;
        if (window.L || attempts > 80) {
          window.clearInterval(timer);
          resolve(window.L || null);
        }
      }, 100);
    });
  }

  function createMarkerIcon(indexLabel, typeKey, isActive) {
    return window.L.divIcon({
      className: "retailer-locator__marker-icon",
      html: `<span class="retailer-locator__marker retailer-locator__marker--${escapeHtml(typeKey || "store")}${isActive ? " is-active" : ""}">${escapeHtml(indexLabel)}</span>`,
      iconSize: [38, 38],
      iconAnchor: [19, 19]
    });
  }

  function createUserMarkerIcon() {
    return window.L.divIcon({
      className: "retailer-locator__user-marker-icon",
      html: '<span class="retailer-locator__user-marker"></span>',
      iconSize: [18, 18],
      iconAnchor: [9, 9]
    });
  }

  function setStatus(sectionState, message) {
    sectionState.elements.status.textContent = message;
  }

  function setMapFallback(sectionState, visible) {
    sectionState.elements.map.hidden = visible;
    sectionState.elements.mapFallback.hidden = !visible;
  }

  function updateTypeFilterButtons(sectionState) {
    sectionState.elements.typeFilterButtons.forEach((button) => {
      const isActive = button.dataset.retailerType === sectionState.typeFilter;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-pressed", String(isActive));
    });
  }

  function setTypeFilter(sectionState, typeFilter) {
    if (!typeFilter || sectionState.typeFilter === typeFilter) {
      return;
    }

    sectionState.typeFilter = typeFilter;
    updateTypeFilterButtons(sectionState);
    applyFilters(sectionState);
  }

  function setActiveStore(sectionState, storeId) {
    if (!storeId || sectionState.activeStoreId === storeId) {
      return;
    }

    sectionState.activeStoreId = storeId;
    sectionState.section.__retailerLocatorStoreState = sectionState.section.__retailerLocatorStoreState || {};
    const selectedStore = sectionState.filteredStores.find((item) => item.id === storeId);
    if (selectedStore) sectionState.section.__retailerLocatorStoreState[storeId] = selectedStore;
    renderList(sectionState);
    renderSelectedStore(sectionState);
    renderMarkers(sectionState, false);
  }

  function renderList(sectionState) {
    const shouldShowAll = sectionState.showAll || sectionState.filterMode !== "default" || !!sectionState.referenceCoords;
    const sourceStores = sectionState.referenceCoords ? sectionState.filteredStores.slice(0, 3) : (shouldShowAll ? sectionState.filteredStores : sectionState.filteredStores.slice(0, sectionState.initialVisible));
    const html = sourceStores.map((store, index) => {
      const distanceText = formatDistance(store.distanceKm);
      const telUrl = toTelUrl(store.phone);
      const mapsUrl = toDirectionsUrl(store);
      const resultClass = store.id === sectionState.activeStoreId ? " is-active" : "";
      const typeClassName = store.typeKey ? ` retailer-locator__result-type--${escapeHtml(store.typeKey)}` : "";

      return `
        <li class="retailer-locator__result${resultClass}" data-store-id="${escapeHtml(store.id)}">
          <article class="retailer-locator__result-card">
            <div class="retailer-locator__result-main">
              <span class="retailer-locator__result-index">${formatIndex(index)}</span>
              <button class="retailer-locator__result-select" type="button" data-store-id="${escapeHtml(store.id)}">
                <span class="retailer-locator__result-row">
                  <span class="retailer-locator__result-name">${escapeHtml(store.name)}</span>
                  ${store.type || distanceText ? `
                    <span class="retailer-locator__result-meta">
                      ${store.type ? `<span class="retailer-locator__result-type${typeClassName}">${escapeHtml(store.type)}</span>` : ""}
                      ${distanceText ? `<span class="retailer-locator__result-distance">${escapeHtml(distanceText)}</span>` : ""}
                    </span>
                  ` : ""}
                </span>
                ${store.address ? `<span class="retailer-locator__result-address">${escapeHtml(store.address)}</span>` : ""}
                ${store.locality ? `<span class="retailer-locator__result-locality">${escapeHtml(store.locality)}</span>` : ""}
                ${telUrl ? `<a class="retailer-locator__result-phone js-retailer-call" href="${escapeHtml(telUrl)}" data-store-id="${escapeHtml(store.id)}">Tel. ${escapeHtml(store.phone)}</a>` : ""}
                ${store.hours ? `<span class="retailer-locator__result-hours">${escapeHtml(store.hours)}</span>` : ""}
              </button>
            </div>
            <div class="retailer-locator__result-actions">
              <a class="retailer-locator__result-link" href="${escapeHtml(mapsUrl)}" target="_blank" rel="noopener noreferrer">Ottieni itinerario</a>
              ${telUrl ? `<a class="retailer-locator__result-link" href="${escapeHtml(telUrl)}">${escapeHtml(sectionState.labels.call)}</a>` : ""}
            </div>
          </article>
        </li>
      `;
    }).join("");

    sectionState.elements.results.innerHTML = html;
    sectionState.elements.empty.hidden = sectionState.filteredStores.length > 0;

    const canExpand = !sectionState.referenceCoords && !shouldShowAll && sectionState.filteredStores.length > sectionState.initialVisible;
    sectionState.elements.moreButton.hidden = !canExpand;
  }

  function bindListEvents(sectionState) {
    sectionState.elements.results.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-store-id]");
      if (!trigger || event.target.closest("a")) {
        return;
      }

      setActiveStore(sectionState, trigger.dataset.storeId);
    });

    sectionState.elements.moreButton.addEventListener("click", () => {
      sectionState.showAll = true;
      renderList(sectionState);
    });

    sectionState.elements.typeFilterButtons.forEach((button) => {
      button.addEventListener("click", () => {
        setTypeFilter(sectionState, button.dataset.retailerType || "all");
      });
    });
  }

  function renderMarkers(sectionState, fitBounds) {
    if (!sectionState.map || !sectionState.markerLayer) {
      return;
    }

    sectionState.markerLayer.clearLayers();

    const bounds = [];
    sectionState.filteredStores.forEach((store, index) => {
      if (store.lat === null || store.lng === null) {
        return;
      }

      const marker = window.L.marker([store.lat, store.lng], {
        icon: createMarkerIcon(formatIndex(index), store.typeKey, store.id === sectionState.activeStoreId)
      });
      marker.on("click", () => {
        sectionState.activeStoreId = store.id;
        renderList(sectionState);
        renderMarkers(sectionState, false);
      });
      marker.bindPopup(`
        <div class="retailer-locator__popup">
          <p class="retailer-locator__popup-title">${escapeHtml(store.name)}</p>
          ${store.type ? `<p class="retailer-locator__popup-meta">${escapeHtml(store.type)}</p>` : ""}
          ${store.address ? `<p class="retailer-locator__popup-text">${escapeHtml(store.address)}</p>` : ""}
          ${store.locality ? `<p class="retailer-locator__popup-text">${escapeHtml(store.locality)}</p>` : ""}
        </div>
      `);
      marker.addTo(sectionState.markerLayer);
      bounds.push([store.lat, store.lng]);

      if (store.id === sectionState.activeStoreId) {
        marker.openPopup();
        if (!fitBounds) {
          sectionState.map.panTo([store.lat, store.lng], { animate: true, duration: 0.4 });
        }
      }
    });

    if (sectionState.referenceCoords) {
      const userMarker = window.L.marker([sectionState.referenceCoords.lat, sectionState.referenceCoords.lng], {
        icon: createUserMarkerIcon()
      });
      userMarker.addTo(sectionState.markerLayer);
      bounds.push([sectionState.referenceCoords.lat, sectionState.referenceCoords.lng]);
    }

    if (!bounds.length) {
      setMapFallback(sectionState, true);
      return;
    }

    setMapFallback(sectionState, false);
    if (fitBounds) {
      if (bounds.length === 1) {
        sectionState.map.setView(bounds[0], 14);
      } else {
        sectionState.map.fitBounds(bounds, {
          padding: [28, 28],
          maxZoom: 14
        });
      }
    }

    window.setTimeout(() => {
      sectionState.map.invalidateSize();
    }, 50);
  }

  function updateStatus(sectionState) {
    const count = sectionState.filteredStores.length;
    if (!count) {
      setStatus(sectionState, sectionState.labels.emptyHeading);
      return;
    }

    const label = count === 1 ? "punto vendita trovato" : "punti vendita trovati";
    const extras = [];
    if (sectionState.typeFilter !== "all") {
      extras.push(`tipo: ${sectionState.filterLabels[sectionState.typeFilter] || sectionState.typeFilter}`);
    }
    if (sectionState.referenceCoords) {
      extras.push(sectionState.referenceLabel ? `ordinati per distanza da ${sectionState.referenceLabel}` : "ordinati per distanza");
    }
    setStatus(sectionState, `${count} ${label}${extras.length ? ` - ${extras.join(" - ")}` : ""}`);
  }

  function applyFilters(sectionState, options = {}) {
    const query = sectionState.elements.input.value.trim().toLowerCase();
    const shouldFilterByText = sectionState.filterMode === "text" && query.length > 0;
    const shouldFilterByType = sectionState.typeFilter !== "all";

    sectionState.filteredStores = sectionState.allStores
      .filter((store) => {
        const matchesText = !shouldFilterByText || store.searchText.includes(query);
        const matchesType = !shouldFilterByType || store.typeKey === sectionState.typeFilter;
        return matchesText && matchesType;
      })
      .map((store) => {
        if (!sectionState.referenceCoords || store.lat === null || store.lng === null) {
          return { ...store, distanceKm: null };
        }

        return {
          ...store,
          distanceKm: haversineDistance(sectionState.referenceCoords, { lat: store.lat, lng: store.lng })
        };
      })
      .sort((storeA, storeB) => {
        if (sectionState.referenceCoords) {
          const distanceA = Number.isFinite(storeA.distanceKm) ? storeA.distanceKm : Number.MAX_SAFE_INTEGER;
          const distanceB = Number.isFinite(storeB.distanceKm) ? storeB.distanceKm : Number.MAX_SAFE_INTEGER;
          return distanceA - distanceB;
        }

        return 0;
      });

    sectionState.showAll = false;

    if (!sectionState.filteredStores.some((store) => store.id === sectionState.activeStoreId)) {
      sectionState.activeStoreId = sectionState.filteredStores[0] ? sectionState.filteredStores[0].id : null;
    }

    renderList(sectionState);
    renderSelectedStore(sectionState);
    updateStatus(sectionState);
    renderMarkers(sectionState, options.fitBounds !== false);
  }

  async function useCurrentLocation(sectionState) {
    if (!navigator.geolocation) {
      setStatus(sectionState, sectionState.labels.locationUnavailable);
      return;
    }

    sectionState.elements.locationButton.classList.add("is-loading");

    try {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 300000
        });
      });

      sectionState.referenceCoords = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      sessionStorage.setItem("iesRetailerLocation", JSON.stringify(sectionState.referenceCoords));
      sectionState.referenceLabel = "la tua posizione";
      sectionState.filterMode = "distance";
      sectionState.elements.input.value = "";
      setLocationContext(sectionState, "la tua posizione (indirizzo in verifica…)");
      applyFilters(sectionState);
      try {
        const address = await reverseGeocode(sectionState.referenceCoords);
        sectionState.referenceLabel = address || "la tua posizione";
      } catch (_) {
        sectionState.referenceLabel = `la tua posizione (${sectionState.referenceCoords.lat.toFixed(5)}, ${sectionState.referenceCoords.lng.toFixed(5)})`;
      }
      setLocationContext(sectionState, sectionState.referenceLabel);
      applyFilters(sectionState);
    } catch (error) {
      setStatus(sectionState, sectionState.labels.locationError);
    } finally {
      sectionState.elements.locationButton.classList.remove("is-loading");
    }
  }

  async function initMap(sectionState) {
    const leaflet = await waitForLeaflet();
    if (!leaflet) {
      setMapFallback(sectionState, true);
      setStatus(sectionState, sectionState.labels.mapError);
      return;
    }

    sectionState.map = leaflet.map(sectionState.elements.map, {
      zoomControl: false,
      scrollWheelZoom: false
    }).setView(defaultCenter, defaultZoom);

    leaflet.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors"
    }).addTo(sectionState.map);

    leaflet.control.zoom({
      position: "bottomright"
    }).addTo(sectionState.map);

    sectionState.markerLayer = leaflet.layerGroup().addTo(sectionState.map);
  }

  async function loadStores(sectionState) {
    const response = await fetch(sectionState.section.dataset.jsonUrl, {
      credentials: "same-origin"
    });

    if (!response.ok) {
      throw new Error(`Failed to load retailer data: ${response.status}`);
    }

    const payload = await response.json();
    return parseDataset(payload);
  }

  async function initSection(section) {
    if (section.dataset.retailerLocatorReady === "true") {
      return;
    }

    section.dataset.retailerLocatorReady = "true";

    const sectionState = {
      section,
      initialVisible: Number.parseInt(section.dataset.initialVisible, 10) || 3,
      activeStoreId: null,
      allStores: [],
      filteredStores: [],
      showAll: false,
      referenceCoords: null,
      referenceLabel: "",
      filterMode: "default",
      typeFilter: "all",
      map: null,
      markerLayer: null,
      elements: {
        form: section.querySelector(selectors.form),
        input: section.querySelector(selectors.input),
        locationButton: section.querySelector(selectors.locationButton),
        typeFilterButtons: Array.from(section.querySelectorAll(selectors.typeFilterButton)),
        status: section.querySelector(selectors.status),
        results: section.querySelector(selectors.results),
        empty: section.querySelector(selectors.empty),
        moreButton: section.querySelector(selectors.moreButton),
        map: section.querySelector(selectors.map),
        selected: section.querySelector(selectors.selected),
        mapFallback: section.querySelector(selectors.mapFallback)
        ,locationContext: section.querySelector(selectors.locationContext)
      },
      labels: {
        emptyHeading: section.dataset.emptyHeading || "Nessun punto vendita trovato",
        locationUnavailable: section.dataset.locationUnavailable || "La geolocalizzazione non Ã¨ supportata su questo dispositivo.",
        locationError: section.dataset.locationError || "Non sono riuscito a recuperare la tua posizione.",
        mapError: section.dataset.mapError || "Mappa non disponibile",
        directions: section.dataset.directionsLabel || "Indicazioni",
        call: section.dataset.callLabel || "Chiama"
      },
      filterLabels: {
        all: "Tutti",
        farmacia: "Farmacia",
        profumeria: "Profumeria"
      }
    };

    updateTypeFilterButtons(sectionState);
    bindListEvents(sectionState);
    const requestForm = section.querySelector("#RetailerStoreRequestForm");
    if (requestForm) requestForm.addEventListener("submit", async (event) => { event.preventDefault(); const modal = section.querySelector(".js-retailer-store-modal"); const card = modal.querySelector(".retailer-locator__modal-card"); const status = modal.querySelector(".js-retailer-modal-status"); const formData = new FormData(requestForm); const payload = Object.fromEntries(formData.entries()); if (payload["contact[cart_contents]"]) payload["contact[body]"] = `${payload["contact[body]"] || "Richiesta Acquista in negozio"}\nCarrello sessione: ${payload["contact[cart_contents]"]}`; const submit = requestForm.querySelector("button[type=submit]"); submit.disabled = true; status.textContent = "Invio in corso..."; try { const response = await fetch(card.dataset.mailerEndpoint, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) }); if (!response.ok) throw new Error(); status.textContent = "Richiesta inviata. Controlla la tua email per la conferma."; requestForm.reset(); } catch (_) { status.textContent = "Non è stato possibile inviare la richiesta. Riprova o contattaci."; } finally { submit.disabled = false; } });
    sectionState.elements.selected.addEventListener("click", (event) => {
      const trigger = event.target.closest(".js-retailer-store-buy");
      if (!trigger) return;
      const store = sectionState.filteredStores.find((item) => item.id === trigger.dataset.storeId);
      const modal = section.querySelector(".js-retailer-store-modal");
      if (!store || !modal) return;
      modal.querySelector(".js-retailer-store-label").textContent = [store.name, store.address, store.locality].filter(Boolean).join(" - ");
      modal.querySelector(".js-retailer-store-name").value = [store.name, store.address, store.locality].filter(Boolean).join(" - ");
      modal.querySelector(".js-retailer-store-body").value = `Richiesta Acquista in negozio - ${store.name}`;
      populateCartSummary(modal);
      modal.hidden = false;
      document.body.classList.add("retailer-locator-modal-open");
    });
    section.querySelectorAll(".js-retailer-store-modal-close").forEach((button) => button.addEventListener("click", () => {
      const modal = section.querySelector(".js-retailer-store-modal");
      if (modal) modal.hidden = true;
      document.body.classList.remove("retailer-locator-modal-open");
    }));

    sectionState.elements.form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const query = sectionState.elements.input.value.trim();

      if (!query) {
        sectionState.referenceCoords = null;
        sectionState.referenceLabel = "";
        setLocationContext(sectionState, "");
        sectionState.filterMode = "default";
        applyFilters(sectionState);
        return;
      }

      setStatus(sectionState, "Ricerca localita in corso...");

      try {
        const match = await geocodeQuery(query);

        if (match) {
          sectionState.referenceCoords = {
            lat: match.lat,
            lng: match.lng
          };
          sectionState.referenceLabel = match.label;
          setLocationContext(sectionState, match.label);
          sectionState.filterMode = "distance";
        } else {
          sectionState.referenceCoords = null;
          sectionState.referenceLabel = "";
          setLocationContext(sectionState, "");
          sectionState.filterMode = "text";
        }
      } catch (error) {
        sectionState.referenceCoords = null;
        sectionState.referenceLabel = "";
        setLocationContext(sectionState, "");
        sectionState.filterMode = "text";
      }

      applyFilters(sectionState);
    });

    sectionState.elements.locationButton.addEventListener("click", () => {
      useCurrentLocation(sectionState);
    });

    try {
      setStatus(sectionState, "Caricamento punti vendita...");
      const [stores] = await Promise.all([
        loadStores(sectionState),
        initMap(sectionState)
      ]);
      sectionState.allStores = stores;
      sectionState.filteredStores = stores.slice();
      const locationParams = new URLSearchParams(window.location.search);
      const requestedLat = Number.parseFloat(locationParams.get("lat"));
      const requestedLng = Number.parseFloat(locationParams.get("lng"));
      if (Number.isFinite(requestedLat) && Number.isFinite(requestedLng)) {
        sectionState.referenceCoords = { lat: requestedLat, lng: requestedLng };
        sectionState.referenceLabel = "la tua posizione";
        sectionState.filterMode = "distance";
        setLocationContext(sectionState, sectionState.referenceLabel);
      }
      sectionState.activeStoreId = locationParams.get("store") || (stores[0] ? stores[0].id : null);
      const requestedProduct = locationParams.get("product");
      const productSelect = section.querySelector(".js-retailer-product");
      if (requestedProduct && productSelect) {
        const productOption = Array.from(productSelect.options).find((option) => option.dataset.handle === requestedProduct);
        if (productOption) productSelect.value = productOption.value;
      }
      applyFilters(sectionState);
    } catch (error) {
      sectionState.filteredStores = [];
      renderList(sectionState);
      setMapFallback(sectionState, true);
      setStatus(sectionState, sectionState.labels.mapError);
    }
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest(".js-retailer-store-buy");
    if (!trigger) return;
    const section = trigger.closest(".js-retailer-locator");
    const modal = section && section.querySelector(".js-retailer-store-modal");
    if (!modal) return;
    const stateStore = section.__retailerLocatorStoreState && section.__retailerLocatorStoreState[trigger.dataset.storeId];
    if (stateStore) { modal.querySelector(".js-retailer-store-label").textContent = [stateStore.name, stateStore.address, stateStore.locality].filter(Boolean).join(" - "); modal.querySelector(".js-retailer-store-name").value = [stateStore.name, stateStore.address, stateStore.locality].filter(Boolean).join(" - "); modal.querySelector(".js-retailer-store-body").value = "Richiesta Acquista in negozio - " + stateStore.name; }
    populateCartSummary(modal);
    modal.hidden = false;
    document.body.classList.add("retailer-locator-modal-open");
  });

  function bootstrap() {
    document.querySelectorAll(selectors.section).forEach((section) => {
      initSection(section);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap, { once: true });
  } else {
    bootstrap();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target.querySelector(selectors.section);
    if (section) {
      initSection(section);
    }
  });
})();


















